:host {
  display: block;
}

.viewfinder {
  --s: 50px;
  --t: 8px;

  padding: calc(var(--t));
  outline-offset: calc(-1 * var(--t));
  mask: conic-gradient(at var(--s) var(--s), #0000 75%, #000 0) 0 0 / calc(100% - var(--s)) calc(100% - var(--s)), linear-gradient(#000 0 0) content-box;
}
